import { render } from "./user-settings.vue?vue&type=template&id=652462a0&scoped=true"
import script from "./user-settings.vue?vue&type=script&lang=js"
export * from "./user-settings.vue?vue&type=script&lang=js"

import "./user-settings.vue?vue&type=style&index=0&id=652462a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652462a0"]])

export default __exports__